export default __webpack_public_path__ + "static/media/10.74e91ca7.webp";